import { StoreModule, ActionReducer } from '@ngrx/store';
import { compose } from '@ngrx/core/compose';
import { combineReducers } from '@ngrx/store';
import { storeFreeze } from 'ngrx-store-freeze';
import { routerReducer } from '@ngrx/router-store';

import { environment } from '../environments/environment';

import { CORE_STORE } from '@c4/core';
import { AUTH_REDUCERS } from '@c4/auth';
import { PROGRAMMING_REDUCERS } from '@c4/programming';
import { SYSMAN_REDUCERS } from '@c4/sysman';

import { aboutReducer } from './about/about.service';
// TODO project-config, programming, devices, etc.

const reducers: any = Object.assign(
  {},
  CORE_STORE,
  AUTH_REDUCERS,
  PROGRAMMING_REDUCERS,
  SYSMAN_REDUCERS,
  {
    about: aboutReducer
  },
  {
    router: routerReducer
  }
);

// TODO see https://github.com/ngrx/example-app/blob/master/src/app/reducers/index.ts for how to strongly type the store
// const developmentReducer: ActionReducer<any> = compose(storeFreeze, combineReducers)(reducers);
const developmentReducer: ActionReducer<any> = compose(combineReducers)(reducers);
const productionReducer: ActionReducer<any> = combineReducers(reducers);

export function reducer(state: any, action: any) {
  if (environment.production) {
    return productionReducer(state, action);
  } else {
    return developmentReducer(state, action);
  }
}



// WEBPACK FOOTER //
// ./src/app/app.stores.ts